import React, { useEffect, useState } from 'react';

import { CarouselReducerAction } from '../../CarouselReducer';
import { RequiredCarouselControlDots } from '../../CarouselInterfaces';

import {
  useBemBlockClassNames,
  useBemElementClassNames,
} from '../../hooks/useBemClassNames';

import Dot from '../dot';

interface DotsProps {
  /**
   * Component global class
   */
  componentClass?: string;
  /**
   *  Number of dot to display
   */
  numberOfDots: number;
  /**
   * Current selected slide index
   */
  currentSlideIndex: number;
  /**
   * Dots settings
   */
  settings: RequiredCarouselControlDots;
  /**
   * Carousel global event dispatcher
   **/
  carouselDispatch: (action: CarouselReducerAction) => void;
}

const Dots = ({
  componentClass = 'dots-list',
  numberOfDots,
  currentSlideIndex,
  settings,
  carouselDispatch,
  ...props
}: DotsProps) => {
  const [mainClasses, setMainClasses] = useState<string[]>([]);

  useEffect(() => {
    const newMainClasses = [
      settings.classes?.component ? settings.classes.component : componentClass,
    ];
    if (settings.classes?.custom) {
      newMainClasses.push(settings.classes.custom);
    }
    setMainClasses(newMainClasses);
  }, [settings, componentClass]);

  const dotsClasses = useBemBlockClassNames(mainClasses);
  const dotsClassesItemElement = useBemElementClassNames(mainClasses, 'item');
  const dots = [];

  for (let dotIndex = 0; dotIndex < numberOfDots; dotIndex++) {
    dots.push(
      <li key={dotIndex} className={`${dotsClassesItemElement}`}>
        <Dot
          isSelected={currentSlideIndex === dotIndex}
          index={dotIndex}
          carouselDispatch={carouselDispatch}
          settings={settings}
          child={settings.items.children[dotIndex] ?? null}
        />
      </li>,
    );
  }
  return (
    <ul {...props} className={`${dotsClasses}`}>
      {dots}
    </ul>
  );
};

export default Dots;
